module.exports = [{
  authorized: true,
  title: 'hzero.common.title.themeConfig',
  path: '/theme-config',
  key: '/theme-config',
  component: function component() {
    return import("../routes/ThemePanel");
  },
  models: []
}, {
  path: '/exception/403',
  component: function component() {
    return import("../routes/Exception/403");
  },
  models: [function () {
    return import("../models/error");
  }]
}, {
  path: '/exception/404',
  component: function component() {
    return import("../routes/Exception/404");
  },
  models: [function () {
    return import("../models/error");
  }]
}, {
  path: '/exception/500',
  component: function component() {
    return import("../routes/Exception/500");
  },
  models: [function () {
    return import("../models/error");
  }]
}, {
  path: '/exception/501',
  component: function component() {
    return import("../routes/Exception/501");
  },
  models: [function () {
    return import("../models/error");
  }],
  key: '/exception/501',
  title: 'hzero.common.title.exception501',
  authorized: true
}, {
  path: '/exception/trigger',
  component: function component() {
    return import("../routes/Exception/triggerException");
  },
  models: [function () {
    return import("../models/error");
  }]
}, {
  path: '/link/:link',
  component: function component() {
    return import("../routes/Link");
  }
}, {
  path: '/iframe/:url',
  authorized: true,
  component: function component() {
    return import("../routes/Iframe");
  }
}, {
  path: '/workplace',
  component: function component() {
    return import("../routes/Dashboard/Workplace");
  },
  models: [function () {
    return import("../models/workplace");
  }]
}, {
  authorized: true,
  path: '/public/unauthorized',
  component: function component() {
    return import("../routes/TokenExpired");
  },
  key: '/public/unauthorized',
  models: []
}, {
  authorized: true,
  path: '/public/kickoff',
  component: function component() {
    return import("../routes/Kickoff");
  },
  key: '/public/kickoff',
  models: []
}, {
  authorized: true,
  path: '/public/self-error',
  component: function component() {
    return import("../routes/SelfError");
  },
  key: '/public/self-error'
}, {
  authorized: true,
  path: '/public/error-message',
  component: function component() {
    return import("../routes/ErrorMessage");
  },
  key: '/public/error-message'
}, {
  authorized: true,
  title: 'hadm.marketclient.view.market.client',
  path: '/market-client',
  key: '/market-client',
  models: [],
  components: [{
    title: 'hadm.marketclient.view.market.client',
    path: '/market-client/home',
    key: '/market-client/home',
    component: function component() {
      return import("../routes/MarketClient/Home");
    },
    models: [function () {
      return import("../models/market");
    }]
  }, {
    title: 'hadm.marketclient.view.home.productList',
    path: '/market-client/product-list',
    key: '/market-client/product-list',
    component: function component() {
      return import("../routes/MarketClient/ProductList");
    },
    models: []
  }, {
    title: 'hadm.marketclient.view.service.list',
    path: '/market-client/services-list',
    key: '/market-client/services-list',
    component: function component() {
      return import("../routes/MarketClient/ServiceList");
    },
    models: []
  }, {
    title: '服务详情',
    path: '/market-client/services-detail/:serviceId',
    key: '/market-client/services-detail/:serviceId',
    component: function component() {
      return import("../routes/MarketClient/ServiceList/Detail");
    },
    models: []
  }, {
    title: '组件/接口/配置对比',
    path: '/market-client/compare/:serviceId/:version',
    key: '/market-client/compare/:serviceId/:version',
    component: function component() {
      return import("../routes/MarketClient/ServiceList/Compare");
    },
    models: []
  }, {
    title: '无网络',
    path: '/market-client/offline',
    key: '/market-client/offline',
    component: function component() {
      return import("../routes/MarketClient/OfflinePage");
    },
    models: []
  }, {
    title: 'hadm.marketclient.view.feedback.title',
    path: '/market-client/feedback',
    key: '/market-client/feedback',
    component: function component() {
      return import("../routes/MarketClient/Feedback");
    },
    models: []
  }]
}, {
  title: '极验校验',
  path: '/gt-demo',
  authorized: true,
  component: function component() {
    return import("../routes/GtDemo");
  }
}];